import { jsx as _jsx } from "react/jsx-runtime";
import Icon from '@cb/solaris-react/Components/Content/Icon';
import Tooltip from '@cb/solaris-react/Components/Interactive/Tooltip/Tooltip';
import { Size } from '@cb/solaris-react/Constants/System';
import styled from 'styled-components';
export default function BottomButtonItem(props) {
    return (_jsx(Tooltip, { text: props.tooltip, placement: 'right', size: Size.small, appendTo: 'parent', children: _jsx(StyledDesktopBottomButtonItem, { onClick: () => props.callback(), children: _jsx(Icon, { name: props.iconName }) }) }));
}
export const StyledBottomButtonItem = styled.div `
	height: ${(props) => props.theme.sizing.md};
	width: ${(props) => props.theme.sizing.md};
	display: flex;
	flex-direction: column;
	color: ${(props) => props.theme.secondary};
	align-items: center;
	justify-content: center;
	position: relative;

	&.selected {
		background-color: ${(props) => props.theme.palette.shade6};
	}

	&:hover {
		background-color: ${(props) => props.theme.palette.shade6};
		cursor: pointer;
	}
`;
const StyledDesktopBottomButtonItem = styled(StyledBottomButtonItem) `
	@media (max-width: ${(props) => props.theme.breakpoints.sm}) {
		display: none;
	}
`;
//# sourceMappingURL=BottomButtonItem.js.map